import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../../../../hooks/useUser";
import { getAbogados } from "../../../../redux/Sections/Abogados/actions";
import { showTable } from "../../../../redux/Sections/Inmuebles/actions";


export const Filter = ({ action, reference, showFilter, setShowFilter, setShowTable }) => {
  const dispatch = useDispatch();
  const user = useUser();

  const {
    register,
    handleSubmit,
    reset
  } = useForm({});

  const [tags, setTags] = useState({});

  useEffect(() => {
    const getData = () => {
      dispatch(getAbogados());
    };

    getData();
  }, []);

  const handleClean = () => {
    reset({});
    setTags({});
  };

  const onSubmit = async (data) => {
    for (const value in data) {
      if (!data[value]) {
        delete data[value];
      }
    }

    setTags(data);

    if (user.rol === "user") {
      data.abogado = user.abogado;
    }
    if (+data.nro) {
      data.nro = +data.nro;
    }

    action(data);

    setShowFilter(false);
    if (setShowTable) {
      setShowTable(true);
    }
    dispatch(showTable());
  };

  const fieldsName = [
    {
      name: "com",
      label: "N° de Comercio",
    },
    {
      name: "cc",
      label: "CUIT",
    },
    {
      name: "contrib",
      label: "Contribuyente",
    },
    {
      name: "fant",
      label: "Fantasía",
    },
    {
      name: "calle",
      label: "Calle",
    },
    {
      name: "nro",
      label: "Altura",
    },
  ];

  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          <Row>
            <Col sm={12} md={6} className="mt-3">
              <Form.Label className="mb-2">N° de Comercio</Form.Label>
              <Form.Control
                name="com"
                {...register("com")}
              />
            </Col>
            <Col sm={12} md={6} className="mt-3">
              <Form.Label className="mb-2">CUIT</Form.Label>
              <Form.Control
                name="cc"
                {...register("cc")}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={6} className="mt-3">
              <Form.Label className="mb-2">Contribuyente</Form.Label>
              <Form.Control
                name="contrib"
                {...register("contrib")}
              />
            </Col>
            <Col sm={12} md={6} className="mt-3">
              <Form.Label className="mb-2">Fantasía</Form.Label>
              <Form.Control
                name="fant"
                {...register("fant")}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={6} className="mt-3">
              <Form.Label className="mb-2">Calle</Form.Label>
              <Form.Control
                name="calle"
                {...register("calle")}
              />
            </Col>
            <Col sm={12} md={6} className="mt-3">
              <Form.Label className="mb-2">Altura</Form.Label>
              <Form.Control
                name="nro"
                type="number"
                {...register("nro")}
              />
            </Col>
          </Row>

          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                ref={reference}
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}
      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(tags).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}
            {fieldsName.map((e) => {
              return tags[e.name] && (
                <div className="tags">
                  <span color="green" key={e.name}>
                    {e.label} : {e.value || tags[e.name]}
                  </span>
                </div>
              );
            })}
          </Row>
        }
      </>
    </div>
  );
};
